import React from "react"
import { Element } from "./style"
import IButtonElement from "./types"

const ButtonElement = (props: IButtonElement) => {
  const { top, skew } = props
  return <Element top={top} skew={skew} />
}

export default ButtonElement
